import {
  langReducer,
  modalReducer,
  oilFilterReducer,
  sortReducer,
  workshopReducer,
  countryReducer,
  countriesReducer,
  replacementReducer,
  serviceIntervalsReducer,
  vehicleComponentVolumesReducer,
  langsReducer,
  selectedLocationReducer,
  whereToBuyEnabledReducer,
  locationTypesListReducer,
  locationCategoriesListReducer,
  productCategoriesListReducer,
  whereToServiceEnabledReducer,
  hasCastrolCertifiedWorkshopsReducer,
} from './reducer';
import {combineReducers, createStore} from 'redux';

const store = createStore(
  combineReducers({
    filter: oilFilterReducer,
    sort: sortReducer,
    workshops: workshopReducer,
    modal: modalReducer,
    lang: langReducer,
    country: countryReducer,
    countries: countriesReducer,
    replacements: replacementReducer,
    serviceIntervals: serviceIntervalsReducer,
    vehicleComponentVolumes: vehicleComponentVolumesReducer,
    langs: langsReducer,
    selectedLocation: selectedLocationReducer,
    whereToBuyEnabled: whereToBuyEnabledReducer,
    locationTypesList: locationTypesListReducer,
    locationCategoriesList: locationCategoriesListReducer,
    productCategoriesList: productCategoriesListReducer,
    whereToServiceEnabled: whereToServiceEnabledReducer,
    hasCastrolCertifiedWorkshops: hasCastrolCertifiedWorkshopsReducer,
  }),
);

export default store;
